import { render, staticRenderFns } from "./MoleculeReasonSelector.vue?vue&type=template&id=48fc16b8"
import script from "./MoleculeReasonSelector.vue?vue&type=script&lang=js"
export * from "./MoleculeReasonSelector.vue?vue&type=script&lang=js"
import style0 from "./MoleculeReasonSelector.vue?vue&type=style&index=0&id=48fc16b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports